import { ColumnType } from 'antd/es/table';
import React from 'react';
import {
  Button, Input, Space,
} from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { escapeRegexStr } from '@ynomia/core/dist/utils';

export const getColumnSearchProps = (
  dataIndex: string,
): ColumnType<any> => ({
  filterDropdown: ({
    setSelectedKeys, selectedKeys, confirm, clearFilters,
  }) => (
    <div
      style={{ padding: 8, paddingTop: 0 }}
      onKeyDown={e => e.stopPropagation()}
      role="button"
      tabIndex={0}
    >
      <Space>
        <Space.Compact>
          <Input.Search
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => confirm()}
            onSearch={() => confirm()}
          />
        </Space.Compact>
        <Button
          onClick={() => {
            if (clearFilters) {
              clearFilters();
            }
            confirm({ closeDropdown: false });
          }}
          size="small"
          style={{ height: 32 }}
        >
          Reset
        </Button>
      </Space>
    </div>
  ),
  filterIcon: (filtered: boolean) => (
    <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
  ),
  onFilter: (value, record) => {
    const filterRegex = new RegExp(escapeRegexStr(`${value}`?.trim()), 'gi');
    return !!JSON.stringify(record[dataIndex])?.match(filterRegex);
  },
  onCell: (text: any) => ({
    children: (
      <div style={{ maxHeight: '100px', overflow: 'auto' }}>
        {text}
      </div>
    ),
  }),
});
